// This file contains linkvis_connector spercific API call functions

// var uinfoAPIPrefix = '/uinfo'
import { useUserManagementClientStoreStore } from 'stores/saasUserManagementClientStore'

let userManagementClientStore = null

const endpointName = 'saas_shorturl'

// const authedStoreFn = 'callAuthedAPI'
const authedOrAnonStoreFn = 'callAuthedOrAnonAPI'

/*
One entry here for ecery prefix ins the python backend app
 matches prefixes foudn in /services/src/APIs/__init__.py
*/
const apiPrefixes = {
  shorturl: { // baseapp provided endpoint
    endpoint: endpointName,
    path: '/user',
    storeFn: authedOrAnonStoreFn, // authedStoreFn or authedOrAnonStoreFn
    orveridePublicPrivatePart: 'private' // public or private
  }
}

function finishEndPointIdentificationHook (rjmStateChange, { serverInfo, apiPrefix }) {
}

function registerEndpoints (rjmStateChange, endpointbaseurl) {
  const finishEndPointIdentificationHookWithRjmStateChange = function (params) {
    finishEndPointIdentificationHook(rjmStateChange, params)
  }

  // Try kong connection first then fallback to non kong
  const possibleApiPrefixes = [
    { prefix: endpointbaseurl, connectingthroughnginx: true, apitype: 'public' },
    { prefix: endpointbaseurl, connectingthroughnginx: false, apitype: 'public' }
  ]
  rjmStateChange.executeAction('registerEndpoint', {
    endpointName,
    apiPrefixIdentificationProcessConfig: {
      possibleApiPrefixes
    },
    finishEndPointIdentificationHookWithRjmStateChange
  })
}

function getMainEndpointName () {
  return endpointName
}

function callApi ({
  prefix, // must match prefix from apiPRefixes array
  router,
  path, // : queryString,
  method, // : 'get',
  postdata, // : null,
  callback, // : callback,
  tenantName
}) {
  if (typeof (apiPrefixes[prefix]) === 'undefined') {
    console.log('ERROR invalid prefix provided to callAPI - ', prefix, apiPrefixes)
    return
  }
  let curPath // = undefined
  if (typeof (router) !== 'undefined') {
    curPath = router.currentRoute.value.fullPath
  }
  const getPathFn = function (tenantName, prefix, path) {
    if (typeof (tenantName) === 'undefined') {
      return apiPrefixes[prefix].path + path
    }
    return apiPrefixes[prefix].path + '/' + tenantName + path
  }
  if (userManagementClientStore === null) {
    userManagementClientStore = useUserManagementClientStoreStore()
  }

  userManagementClientStore[apiPrefixes[prefix].storeFn]({
    endpoint: apiPrefixes[prefix].endpoint,
    path: getPathFn(tenantName, prefix, path),
    method,
    postdata,
    callback,
    curpath: curPath,
    orveridePublicPrivatePart: apiPrefixes[prefix].orveridePublicPrivatePart
  })
}

export default {
  callApi,
  getMainEndpointName,
  registerEndpoints
}
